<template>
  <div id="depart-date-too-early-modal">
    <el-dialog title="重要提示" v-model="showModal" custom-class="depart-dialog" :show-close="false">
      <span>您的{{type === 1 ? '出行日期' : '签证生效日期'}}过早，在规定的办理时长内无法出签，请更改{{type === 1 ? '出行日期' : '签证生效日期'}}！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelModifyDepartDate">取消</el-button>
        <el-button type="primary" @click="modifyDepartDate(type)">更改日期</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'depart-date-too-early-modal',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    type: {
      type: Number,
      required: true,
      default: 1,
    },
  },
  data() {
    return {
      showModal: this.value,
    };
  },
  methods: {

    // 弹出修改出行日期（或签证生效日期）的提示框
    modifyDepartDate(type) {
      if (type === 1) {
        document.querySelector('#order-comfirm-infos .depart-date-box .date-content-box').click();
      } else if (type === 2) {
        document.querySelector('#order-comfirm-infos .effect-date-box .date-content-box').click();
      }
      this.$emit('input', false);
    },

    // 取消就直接跳转到订单列表
    cancelModifyDepartDate() {
      this.$emit('input', false);
      this.$router.push({ path: '/orders' });
    },
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
    },
  },
};
</script>

<style lang="less">
#depart-date-too-early-modal {
  .depart-dialog {
    width: 480px;
    text-align: center;
    border-radius: 5px;

    .el-dialog__header {
      padding-top: 48px;
    }

    .el-dialog__title {
      font-size: 22px;
      color: #333;
      font-weight: 300;
    }

    .el-dialog__body {
      font-size: 18px;
      padding: 38px 20px;
      line-height: 1.5;
    }

    .el-dialog__footer {
      text-align: center;
      padding-bottom: 38px;

      .el-button {
        width: 150px;
        font-size: 16px;

        & + .el-button {
          margin-left: 22px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/modals/depart-date-too-early-modal.vue